import { AttributionControl } from 'react-map-gl/maplibre';
import { DATA_SOURCE_ATTRIBUTIONS } from './mapAttributionSources';

/**
 * Contrôle d'attribution MapLibre obligatoire (finding audit H9).
 *
 * Compact/repliable par défaut (icône "i"), mais toujours présent : IGN
 * (Licence Ouverte 2.0), OpenStreetMap (ODbL — attribution obligatoire),
 * BDNB (© CSTB), Cadastre (© DGFiP/Etalab). Voir mapAttributionSources.ts et
 * docs/DATA_SOURCES.md pour le détail des licences.
 *
 * À ajouter comme enfant de tout composant `<Map>` (react-map-gl/maplibre)
 * du frontend — il n'existe pas de point d'initialisation partagé unique
 * pour les cartes Terravision (chaque écran instancie son propre `<Map>`).
 */
export function DataAttribution() {
  return (
    <AttributionControl
      compact
      customAttribution={[...DATA_SOURCE_ATTRIBUTIONS]}
      position="bottom-right"
    />
  );
}
